import { ISetPageTypeAction } from "../interfaces/utils.interface";
export function setPageType(pageType: string | null): ISetPageTypeAction {
  return {
    type: "SET_PAGE_TYPE",
    data: pageType,
  };
}
